import axios from "axios";
import { Urls } from "../../urls";
import { ServiceUrls } from "../../../store/serviceUrls";

// /home/shivani/Documents/Projects/cnext-frontend-cms/src/store/serviceUrls.js
export const baseURL = ServiceUrls.DEB_SERVICE_API
export const getDebFilterRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_DEB_FILTER_API,
        params: params,
    });
};

export const getDebListingRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_DEB_LISTING_API,
        params: params,
    });

}


export const getNewsLetterRepo = (params) => {
    return axios({
        method: "GET",
        url: Urls.GET_NEWS_LETTER_API,
        params: params,
    });

}
export const patchWeightUpdateRepo = (data) => {
    return axios({
        method: "PATCH",
        url: Urls.PATCH_WEIGHT_UPDATE_API,
        data: data,
    });

}

export const postUpdateNewsLetterRepo = (data) => {
    return axios({
        method: "POST",
        url: Urls.GET_NEWS_LETTER_API,
        data: data,
    });

}

export const deleteNewsLetterItemsRepo = (data) => {
    return axios({
        method: "DELETE",
        url: Urls.GET_NEWS_LETTER_API,
        data: data,
    });

}

export const postNewsLetterPreviewRepo = async (data) => {
    // Use fetch instead of axios because `axios.defaults.env.FormData = appConfig`
    // in App.js corrupts axios's internal env, causing response.data to be undefined
    // for text/html responses. Fetch is unaffected by that override.
    const fullUrl = baseURL + Urls.GET_NEWS_LETTER_PREVIEW_API;

    // Re-use the same auth headers that axios has set globally
    const authHeader = axios.defaults.headers.common["Authorization"];
    const apiKey = axios.defaults.headers.common["x-api-key"];

    const res = await fetch(fullUrl, {
        method: "POST",
        credentials: "include",
        headers: {
            "Content-Type": "application/json",
            ...(apiKey ? { "x-api-key": apiKey } : {}),
            ...(authHeader ? { "Authorization": authHeader } : {}),
        },
        body: JSON.stringify(data),
    });

    const htmlText = await res.text();

    // Return an axios-shaped object so the slice code needs no changes
    return {
        status: res.status,
        statusText: res.statusText,
        data: htmlText,
    };
}


export const postNewsLetterTestRunRepo = (data) => {
    return axios({
        baseURL,
        method: "POST",
        url: Urls.POST_NEWSLETTER_TEST_RUN_API,
        data: data,
    });
}

export const postDebListingLiveSyncRepo = (data) => {
    return axios({
        baseURL,
        method: "POST",
        url: Urls.POST_LIVE_SYNC_API,
        data: data,
    });
}


export const getNewsLetterCalendarRepo = (data) => {
    return axios({
        method: "GET",
        url: Urls.GET_NEWSLETTER_CALENDAR_API,
        params: data,
    });

}





